'use strict';

class NotificationsListController {
  constructor($scope,
              $timeout,
              $rootScope,
              $filter,
              $state,
              $stateParams,
              $q,
              $interval,
              utils,
              config,
              OrganizationService,
              LocationsService,
              TagsService,
              PermissionsService,
              ToastsService,
              I18nService) {

    const $t = $filter('translate');
    const locale = I18nService.getLocale()?.code || 'en';
    const ORGANIZATIONS_LOCAL_STORAGE_KEY = 'Organizations-All';
    const CURRENT_ORG_LOCAL_STORAGE_KEY = 'Organizations-Current';
    const SELECTED_NOTIFICATION_LOCAL_STORAGE_KEY = 'Selected-Notification';
    const NOTIFICATION_REFRESH_RATE_MS = 10000;
    // Filter constants
    const CACHE_FILTER = true;
    // Request constants
    const REQUEST_LIMIT = 100;
    const INITIAL_DAYS = 7;

    // Last used today's endDate (to use in fresh narrative loading)
    let lastRetrievedDate;

    // Initial narratives
    let narrativesList = [];

    $scope.initialDays = INITIAL_DAYS;
    $scope.chooseOrg = utils.getStorageItem(CURRENT_ORG_LOCAL_STORAGE_KEY);
    $scope.allOrgs = utils.getStorageItem(ORGANIZATIONS_LOCAL_STORAGE_KEY);
    $scope.timestampFormatStr = $t('datetime.HMS12');
    $scope.timeFormatStr = $t('datetime.events.date');
    $scope.timezone = moment.tz.guess();

    $scope.loadingNarratives = false;
    $scope.loadingMoreNarratives = false;
    $scope.loadingFreshNarratives = false;
    $scope.loadingDeleteNarrative = false;
    $scope.loadingUpdateNarrative = false;
    $scope.initialLoading = true;

    const NOTIFICATIONS_FILTER_LOCAL_STORAGE_KEY = 'Filter-Notifications-' + $scope.chooseOrg.id;

    // Put on scope only the stuff we really need there
    angular.extend($scope, {
      viewEvent: viewEvent,
      getNotificationTitle: getNotificationTitle,
      updateNotification: updateNotification,
      canEditNotification: canEditNotification,
      canDeleteNotification: canDeleteNotification,
      canViewLocations: canViewLocations,
      canManageNotificationGroups: canManageNotificationGroups,
      gotoLocation: gotoLocation,
      gotoNotificationGroups: gotoNotificationGroups,

      // Filter
      filterNotifications: filterNotifications,
      toggleFilter: toggleFilter,
      isFilterDirty: isFilterDirty,
      closeFilter: closeFilter,
      resetFilter: resetFilter
    });

    // Events (narravites) specific constants
    const narrativePriorities = config.getConfigByKey('narrativePriorities');
    $scope.availablePriorities = narrativePriorities.filter(el => !el.hidden);
    $scope.availableStatuses = config.getConfigByKey('narrativeStatuses');
    $scope.notificationTypes = config.getConfigByKey('narrativeTypes');

    // Narratives datepicker options
    $scope.eventsDatePickerOptions = {
      language: locale,
      position: 'bottom left',
      view: 'days',
      minView: 'days',
      autoClose: true,
      maxDate: new Date(),
      clearButton: true,
      dateFormat: 'm/dd/yyyy',
      range: true,
      // toggleSelected: false
    };

    // Remove notification delete modal
    $scope.$on('$destroy', () => {
      $('#delete-notification-dialog').remove();
    });

    init();

    // Please, no code execution below this line - only function definitions
    // ---------------------------------------------------------------------

    function init() {
      $scope.initialLoading = true;
      initFilter()
        .then(() => {
          initFreshNarrativesLoading();
          initInfiniteScroll();
          $scope.initialLoading = false;
        })
        .catch((err) => {
          utils.handleApiError(err);
          $scope.initialLoading = false;
        });

      // #region Narratives Notifications

      $scope.$on('highlightNarrative', (event, data) => {
        $scope.highlightNarrativeId = data.highlight;
        // TODO highlight it somehow?
        if (!$scope.narratives.some(n => n.id === $scope.highlightNarrativeId) && isFilterDirty()) {
          resetFilter();
        }
      });

      if ($stateParams.highlight) {
        $scope.highlightNarrativeId = $stateParams.highlight;
      }

      // #endregion
    }

    // #region Filter Methods -----------------------------------------------

    function initFilter() {
      $scope.filter = {
        dateRange: null,
        notificationType: 0,
        searchVal: $stateParams.searchBy || ''
      };

      if (!isFilterDirty()) { // restore from cache only if nothing was transferred via URL query parameters
        initFilterFromCache();
      }

      saveFilter();

      // Watchers
      $scope.$watch('filter.dateRange', function(newValue, oldValue) {
        if ($scope.initialLoading || $scope.loadingNarratives || $scope.loadingMoreNarratives || $scope.loadingDeleteNarrative || $scope.loadingUpdateNarrative) {
          return;
        }
        if (newValue === oldValue) {
          return;
        }
        filterNotifications();
      }, true);

      // Get child organizations if they are exist
      $scope.childOrgs = !$scope.chooseOrg.parentId
        ? utils.getChildOrganizations($scope.allOrgs, $scope.chooseOrg.id)
        : [];

      return getLocationTags();
    }

    /**
     * Init filter object from localStorage cache
     */
    function initFilterFromCache() {
      if (CACHE_FILTER) {
        let params = utils.getStorageItem(NOTIFICATIONS_FILTER_LOCAL_STORAGE_KEY);

        // Fix for timestamp
        if (params) {
          if (params.dateRange && params.dateRange.length !== 0) {
            params.dateRange = params.dateRange.map(el => new Date(el));
            params.notificationType = 0;
          }
        }

        $scope.filter = params || {
          dateRange: null,
          notificationType: 0
        };
      }
    }

    /**
     * Save filter to localStorage
     */
    function saveFilter() {
      if (CACHE_FILTER) {
        utils.setStorageItem(NOTIFICATIONS_FILTER_LOCAL_STORAGE_KEY, $scope.filter);
      }
      narrativesList = [];
      $scope.narratives = [];
      $scope.narrativesCount = 0;
      loadNarratives();
    }

    /**
     * Is filter has some values set
     * @param {boolean} filterOnly To check only filter without search value
     * @return {boolean}
     */
    function isFilterDirty(filterOnly) {
      if (!$scope.filter) {
        return false;
      }
      let tempFilter = angular.copy($scope.filter);

      // Dummy fix for null values
      if (tempFilter.priority === 0) {
        tempFilter.priority = 99;
      }
      if (tempFilter.status === 0) {
        tempFilter.status = 99;
      }

      if (filterOnly) {
        tempFilter.searchVal = null;
        tempFilter.dateRange = null;
      }
      return Object.keys(tempFilter)
        .some(key => !!tempFilter[key]);
    }

    /**
     * Toggle filter UI visibility
     */
    function toggleFilter() {
      $('#filter').transition('fade down');
    }

    /**
     * Hide filter UI
     */
    function closeFilter() {
      let visible = $('#filter').transition('is visible');
      if (visible) {
        $('#filter').transition('hide');
      }
    }

    function resetFilter() {
      if ($scope.initialLoading || $scope.loadingNarratives || $scope.loadingMoreNarratives || $scope.loadingDeleteNarrative || $scope.loadingUpdateNarrative) {
        return;
      }
      $scope.filter = {
        notificationType: 0
      };
      $scope.selectedNotificationPriorityObj = void 0;
      $scope.selectedNotificationStatusObj = void 0;
      $scope.selectedLocationTag = void 0;
      $scope.selectedChildOrg = void 0;
      $scope.selectedChildOrg = void 0;
      filterNotifications();
    }

    function filterNotifications() {
      if ($scope.initialLoading || $scope.loadingNarratives || $scope.loadingMoreNarratives || $scope.loadingDeleteNarrative || $scope.loadingUpdateNarrative) {
        return;
      }
      closeFilter();
      saveFilter();
    }

    // #endregion

    // #region Main Functions ------------------------------------------------

    function canEditNotification(notification) {
      return PermissionsService.canIEditNotification(notification);
    }

    function canDeleteNotification(notification) {
      return PermissionsService.canIDeleteNotification(notification);
    }

    function canViewLocations() {
      return PermissionsService.canIViewLocationList();
    }

    function canManageNotificationGroups() {
      return PermissionsService.canIEditOrganization($scope.chooseOrg);
    }

    function gotoNotificationGroups() {
      if (!canManageNotificationGroups) {
        return;
      }
      $state.go('main.notifications.groups.list');
    }

    function gotoLocation(notification) {
      if (!notification.locationId || notification.narrativeType) {
        return viewEvent(notification);
      }

      $state.go('main.locations.edit', {
        locationId: notification.locationId,
        from: 'notifications'
      });
      $rootScope.$emit('refreshChooseMenuEvent', 'locations');
    }

    function initInfiniteScroll() {
      $('#narrative-list-container')
        .visibility({
          once: false,
          // update size when new content loads
          observeChanges: true,
          // load content on bottom edge visible
          onBottomVisible: function() {
            $scope.$applyAsync(() => {
              showMore();
            });
          }
        });
    }

    function initFreshNarrativesLoading() {
      // Autoupdate Narratives every N seconds
      let intervalPromise = $interval(() => {
        if ($scope.initialLoading || $scope.loadingFreshNarratives || $scope.loadingNarratives || $scope.loadingMoreNarratives) {
          return;
        }

        if (!lastRetrievedDate) {
          return;
        }

        if (!$scope.filter.dateRange || $scope.filter.dateRange.length === 0 || moment($scope.filter.dateRange[$scope.filter.dateRange.length - 1]).tz($scope.timezone).endOf('day').valueOf() === moment().tz($scope.timezone).endOf('day').valueOf()) {

          $scope.loadingFreshNarratives = true;
          getOrgNarratives(undefined, false, lastRetrievedDate + 1)
            .then(() => {
              $scope.loadingFreshNarratives = false;
            });
        }

      }, NOTIFICATION_REFRESH_RATE_MS);

      $scope.$on('$destroy', () => {
        $interval.cancel(intervalPromise);
      });
    }

    function showMore() {
      if (!$scope.narratives || $scope.narrativesCount <= 0 || !$scope.nextPageMarker || $scope.loadingNarratives || $scope.loadingMoreNarratives) {
        return;
      }
      $scope.loadingMoreNarratives = true;
      getOrgNarratives($scope.nextPageMarker, true)
        .then(() => {
          $scope.loadingMoreNarratives = false;
        });
    }

    function loadNarratives() {
      $scope.loadingNarratives = true;
      getOrgNarratives(undefined, true)
        .then(() => {
          $scope.loadingNarratives = false;
        });
    }

    /**
     * Get narratives list by parameters
     * @param {string} [pageMarker]
     * @param {boolean} [updatePageMarker] true to update page marker. Defaults to true
     * @return {Promise}
     */
    function getOrgNarratives(pageMarker, updatePageMarker = true, startDate) {
      let params = {
        rowCount: REQUEST_LIMIT
      };

      if (!$scope.filter.dateRange || $scope.filter.dateRange.length === 0) {
        params.startDate = moment()
          .tz($scope.timezone)
          .startOf('day')
          .subtract(6, 'days')
          .valueOf();
      } else {
        let endDate = $scope.filter.dateRange[$scope.filter.dateRange.length - 1];
        params.startDate = moment($scope.filter.dateRange[0])
          .tz($scope.timezone)
          .startOf('day')
          .valueOf();
        params.endDate = moment(endDate)
          .tz($scope.timezone)
          .endOf('day')
          .valueOf();
      }

      lastRetrievedDate = undefined;
      if (startDate || !params.endDate || params.endDate === moment().tz($scope.timezone).endOf('day').valueOf()) {
        // Enable fresh narratives loading.
        // We request events only up to a certain moment,
        //  so that it is clear to us which events are new,
        //  and which the server simply did not have time to
        //  process (for example, in the event of an update or remove)
        params.endDate = new Date().getTime();
        lastRetrievedDate = params.endDate;
      }

      if (startDate) {
        params.startDate = startDate;
      }

      if (pageMarker) {
        params.pageMarker = pageMarker;
      }

      // If filter cached or filled
      if ($scope.filter) {
        if ($scope.filter.priority || $scope.filter.priority === 0) {
          params.priority = $scope.filter.priority;
          params.toPriority = $scope.filter.priority;
        }
        if ($scope.filter.searchVal) {
          let isNumber = /^\d+$/.test($scope.filter.searchVal);
          if (isNumber && $scope.filter.searchVal != 0) {
            params.locationId = parseInt($scope.filter.searchVal);
          } else {
            params.searchBy = $scope.filter.searchVal + '*';
          }
        }
        if ($scope.filter.locationTag) {
          params.searchTag = $scope.filter.locationTag;
        }
        if ($scope.filter.status || $scope.filter.status === 0) {
          params.status = $scope.filter.status;
        }
        if ($scope.filter.notificationType) {
          params.narrativeType = $scope.filter.notificationType;
        }
      }

      let organizationId = ($scope.filter ? $scope.filter.orgId : void 0) || $scope.chooseOrg.id;

      return OrganizationService.getOrganizationNarratives(organizationId, params)
        .then(data => {
          if (updatePageMarker) {
            if (data.nextMarker) {
              $scope.nextPageMarker = data.nextMarker;
            } else {
              delete $scope.nextPageMarker;
            }
          }

          if (!data.narratives) {
            return;
          }

          narrativesList = narrativesList
            // concatenate existing narratives with newcomers
            .concat(data.narratives || [])
            // Remove duplicates
            .filter((narrative, index, self) => index === self.findIndex((n) => n.id === narrative.id))
            // and sort by date
            .sort((a, b) => b.narrativeDateMs - a.narrativeDateMs);

          let groupedNarrativeList = utils.groupByDateParam(narrativesList, 'narrativeDateMs', $scope.timezone);

          $scope.narratives = groupedNarrativeList;
          $scope.narrativesCount = narrativesList ? narrativesList.length : 0;
        }, (err) => {
          utils.handleApiError(err);
        });
    }

    /**
     * Get location tags for current organization
     * @return {Promise}
     */
    function getLocationTags() {
      return TagsService
        .getPopularTags($scope.chooseOrg.id, 2, 100) // 2 = location tags
        .then(data => {
            $scope.locationTags = data.tags;
          },
          err => {
            utils.handleApiError(err);
          });
    }

    /**
     * Goto Notification Details page
     */
    function viewEvent(notification, $event) {
      utils.setStorageItem(SELECTED_NOTIFICATION_LOCAL_STORAGE_KEY, notification);
      $state.go('main.notifications.info');
    }

    /**
     * Generates title if title is missing
     */
    function getNotificationTitle(type) {
      const narrativeType = type && $scope.notificationTypes.find(t => type === t.id);
      return narrativeType ? $t(narrativeType.desc) : $t('events.types.unknown');
    }

    /**
     * Delete narrative (set status to 1)
     */
    function deleteNotification(notification, parentIndex, $index) {
      if (!notification || notification.status === 1) {
        return;
      }

      $('#delete-notification-dialog')
        .modal({
          closable: false,
          detachable: true,
          onApprove: function() {
            $scope.loadingDeleteNarrative = true;
            return LocationsService.deleteNarrative(notification.locationId, notification.id, notification.narrativeDateMs)
              .then(() => {
                $scope.$applyAsync(() => {
                  $scope.loadingDeleteNarrative = false;

                  // Remove narrative from the list
                  $scope.narratives[parentIndex].collection.splice($index, 1);
                  if ($scope.narratives[parentIndex].collection.length === 0) {
                    $scope.narratives.splice(parentIndex, 1);
                  }

                });
                ToastsService.success(null, $t('events.deleteNotification.success'));
              }, err => {
                $scope.loadingDeleteNarrative = false;
                utils.handleApiError(err);
              });
          }
        }).modal('show');
    }

    /**
     * Updates notification status
     * @param {Object} notification
     * @param {string} action
     */
    function updateNotification(notification, parentIndex, $index, action) {
      if (!notification || !action) {
        return;
      }
      let message = $t('events.resolve');
      switch (action) {
        case 'resolve':
          return updateNotificationStatus(notification, parentIndex, $index, 2, message);
        case 'reopen':
          message = $t('events.reopen');
          return updateNotificationStatus(notification, parentIndex, $index, 0, message);
        case 'delete':
          return deleteNotification(notification, parentIndex, $index);
      }
    }

    function updateNotificationStatus(notification, parentIndex, $index, status, message) {
      if (notification.status === status) {
        return;
      }

      let narrative = {
        status: status
      };

      $scope.loadingUpdateNarrative = true;
      return LocationsService.updateNarrative(notification.locationId, 2, narrative, notification.id, notification.narrativeDateMs)
        .then(data => {
          $scope.$applyAsync(() => {
            $scope.loadingUpdateNarrative = false;
            $scope.narratives[parentIndex].collection[$index].status = status;
            if ($scope.filter.status != null && $scope.filter.status !== status) {

              // Remove narrative from the list
              $scope.narratives[parentIndex].collection.splice($index, 1);
              if ($scope.narratives[parentIndex].collection.length === 0) {
                $scope.narratives.splice(parentIndex, 1);
              }

            } else {
              $scope.narratives[parentIndex].collection[$index].status = status;
            }
          });
          ToastsService.success(null, message);
        }, err => {
          $scope.loadingUpdateNarrative = false;
          utils.handleApiError(err);
        });
    }

    // #endregion

  }
}

export default angular
  .module('main.notificationsList.controller', [])
  .controller('NotificationsListController', NotificationsListController)
  .name;
